import { NbDialogService } from "@nebular/theme";
import { EImportacaoType } from "../components/table/EImportacaoType";
import { ILoteDetalhes } from "../dto/ILoteDetalhes";
import { EAcaoType } from "../enums/EAcaoType";
import { ModalAcaoComponent } from "../components/modals/modal-acao/modal-acao.component";
import { EColumnType } from "../components/table/EColumnType";

export function getDialogCancel(
  dialogService: NbDialogService,
  loteDetalhes: ILoteDetalhes,
  importacaoType: EImportacaoType,
  onClose: (result) => void
) {
  dialogService
    .open(ModalAcaoComponent, {
      closeOnBackdropClick: false,
      closeOnEsc: false,
      context: {
        data: getDataModal(loteDetalhes, importacaoType),
      },
    })
    .onClose.subscribe(onClose);
}

function getDataModal(
  loteDetalhes: ILoteDetalhes,
  importacaoType: EImportacaoType
) {
  switch (importacaoType) {
    case EImportacaoType.CARGA:
      return {
        title: "Cancelar carga",
        messageFooter: "Tem certeza que deseja cancelar a carga?",
        acaoType: EAcaoType.CANCELAR,
        data: [
          { label: "ID", value: loteDetalhes.id, type: EColumnType.NUMBER },
          {
            label: "Data da carga",
            value: loteDetalhes.dataCadastro,
            type: EColumnType.DATE,
          },
          {
            label: "Quantidade de colaboradores",
            value: loteDetalhes.totalRegistros,
            type: EColumnType.NUMBER,
          },
          {
            label: "Valor carga",
            value: loteDetalhes.valorTotal,
            type: EColumnType.CURRENCY,
          },
        ],
      };
    case EImportacaoType.FUNCIONARIO:
      return {
        title: "Cancelar cadastro",
        messageFooter: "Tem certeza que deseja cancelar o cadastro?",
        acaoType: EAcaoType.CANCELAR,
        data: [
          {
            label: "Nome do arquivo",
            value: loteDetalhes.nomeArquivo,
            type: EColumnType.STRING,
          },
          {
            label: "Data de criação",
            value: loteDetalhes.dataCadastro,
            type: EColumnType.DATE,
          },
        ],
      };
    default: {
    }
  }
}
